import { JsonPipe } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatFormField, MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { provideDateFnsDatetimeAdapter } from '@ng-matero/extensions-date-fns-adapter';
import { MtxDatetimepickerModule } from '@ng-matero/extensions/datetimepicker';
import { ja } from 'date-fns/locale';

@Component({
  selector: 'app-datetime-picker',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormField,
    MtxDatetimepickerModule,
    JsonPipe,
    MatIcon,
    MatTooltipModule,
    MatIconModule,
  ],
  providers: [
    {
      provide: MAT_DATE_LOCALE,
      useValue: ja,
    },
    provideDateFnsDatetimeAdapter({
      parse: {
        dateInput: 'yyyy/MM/dd',
        monthInput: 'MM',
        yearInput: 'yyyy',
        timeInput: 'HH:mm',
        datetimeInput: 'yyyy/MM/dd HH:mm',
      },
      display: {
        dateInput: 'yyyy/MM/dd',
        monthInput: 'MM',
        yearInput: 'yyyy',
        timeInput: 'HH:mm',
        datetimeInput: 'yyyy/MM/dd HH:mm',
        monthYearLabel: 'yyyy/MM',
        dateA11yLabel: 'yyyy/MM/dd',
        monthYearA11yLabel: 'yyyy/MM',
        popupHeaderDateLabel: 'yyyy/MM/dd',
      },
    }),
  ],
  templateUrl: './datetime-picker.component.html',
  styleUrl: './datetime-picker.component.scss',
})
export class DatetimePickerComponent implements OnChanges {
  @Input({ required: true }) formGroup!: FormGroup;
  @Input() arrayName: string = '';
  @Input({ required: true }) controlName!: string;
  @Input() type: 'datetime' | 'date' | 'time' = 'datetime';
  @Input() labelMessage: string = '';
  @Input() toolTipMessage: string | undefined = undefined;
  @Input() width: string = '370px';

  @Input() numberOfMonths: number | undefined;
  public placeholder = 'YYYY/MM/dd HH:mm';
  public formWidthClass = `tw-w-[${this.width}]`;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['type'] !== undefined) {
      const pickerType = changes['type'].currentValue;
      let defaultPlaceholder: string = '';
      switch (pickerType) {
        case 'date':
          defaultPlaceholder = 'YYYY/MM/dd';
          break;
        case 'time':
          defaultPlaceholder = 'HH:mm';
          break;
        default:
          defaultPlaceholder = 'YYYY/MM/dd HH:mm';
          break;
      }
      this.placeholder = defaultPlaceholder;
    }
    if (changes['width'] !== undefined) {
      this.formWidthClass = `tw-w-[${this.width}]`;
    }
  }
}
